<template>
  <div style="width: 100%;">
    <UiNav
      v-if="isMobile"
      :class="{'mb-4' : selectTab === 'Карта'}"
      :tabs="tabs"
      :select-tab="selectTab"
      @selectTab="selectTab = $event"
    />
    <div class="calculator-map-modal__wrapper">
      <ODPModalMobile
        v-if="isMobile && ODPPreview && ODPPreview.id && selectTab === 'Карта'"
        :o-d-p-preview="ODPPreview"
        class="calculator-map-modal__odp-modal-mobile"
      />
      <YmapsView
        v-show="!isMobile || selectTab === 'Карта'"
        ref="ymapsCalculatorWidget"
        style="height: 439px;"
        class="layouts__container calculator-map-modal__container"
        :show-o-d-p-preview="showODPPreview"
        :odp="collection"
        :o-d-p-preview="ODPPreview"
        :checked-odp="setOdp"
        :select-odp-by-list="selectOdpByList"
      />
      <CalcPointsList
        v-show="!isMobile || selectTab === 'Список'"
        class="calculator-points-list"
        :odp="collection"
        :o-d-p-preview="ODPPreview"
        @checkPoint="checkPoint"
        @selectOdp="selectOdpByList = $event"
      />
    </div>
  </div>
</template>

<script>
import CalcPointsList from './CalcPointsList.vue';
import UiNav from '../UIComponents/UiNav.vue';
import deviceInfo from '../../helpers/device';
import ODPModalMobile from './ODPModalMobile.vue';
import YmapsView from './YmapsView.vue';

export default {
  name: 'CalculatorMap',
  components: {
    ODPModalMobile,
    UiNav,
    CalcPointsList,
    YmapsView,
  },
  props: {
    collection: Array,
    person: String,
  },
  data() {
    return {
      ODPPreview: {},
      setOdp: null,
      odpForBuild: {},
      selectOdpByList: {},
      tabs: ['Карта', 'Список'],
      selectTab: 'Карта',
    };
  },
  computed: {
    ...deviceInfo,
  },
  methods: {
    showODPPreview(odp) {
      this.ODPPreview = odp.data;
      this.$bvModal.show('ODPPreviewModal');
    },
    checkPoint(odp) {
      this.setOdp = odp;
      this.$emit('checkPoint', odp, this.person);
    },
    removeCheckPoint() {
      this.setOdp = null;
      this.$emit('removeCheckPoint', this.person);
    },
    closeOdpPreview() {
      this.ODPPreview = {};
    },
  },
};
</script>

<style lang="scss" scoped>

  .map__container.map__container_card {
    width: 100% !important;
  }

  @media (min-width: 1024px) {

    .town__close.calculator-map-modal__close {
      background: #ed1651 url("data:image/svg+xml,%3Csvg width='29' height='28' viewBox='0 0 29 28' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M12.5 10.92L24.46-.582a1.5 1.5 0 0 1 2.08 2.162L14.664 13 26.54 24.419a1.5 1.5 0 0 1-2.08 2.162l-11.96-11.5L.54 26.58a1.5 1.5 0 0 1-2.08-2.162L10.336 13-1.54 1.581A1.5 1.5 0 0 1 .54-.58l11.96 11.5z' id='a'/%3E%3C/defs%3E%3Cuse fill='%23FFF' fill-rule='nonzero' xlink:href='%23a' transform='translate(2 1)'/%3E%3C/svg%3E") center no-repeat;
      width: 37px;
      height: 37px;
    }
  }

  .layouts__container.calculator-map-modal__container {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: none;
    flex-shrink: 0;
    margin-right: 51px;
    max-width: 600px;

    @media (min-width: 768px) {
      height: 330px;
    }
    @media (max-width: 767px) {
      height: 260px !important;
      margin-right: 0;
      border-radius: 8px;
    }
  }

  .calculator-map-modal__wrapper {
    display: flex;
    width: 100%;
    @media (max-width: 767px) {
      flex-direction: column;
    }
  }
  .calculator-points-list {
    flex-grow: 1;
  }
  .calculator-map-modal__odp-modal-mobile {
    @media (max-width: 767px) {
      order: 2;
    }
  }
</style>
